import { RootState } from '../../types';

export const selectUser = (store: RootState) => store.auth.user;
export const selectIsLoggedIn = (store: RootState) => !!store.auth.user;
